/**
 * How many reads a write needs before caching a prefix beat not caching it.
 *
 * A 1-hour write bills at 2x input and a read at 0.1x, but the turn that wrote the prefix would
 * have paid 1x for those same tokens uncached. So caching costs 1x extra once and saves 0.9x on
 * every later read, and pays for itself after (2 - 1) / (1 - 0.1) reads per write.
 *
 * Derived rather than written down: 2.2 divided the write's whole 2x by the saving, charging the
 * first turn for tokens it was going to send anyway. At 1.68 reads per write - the real window this
 * module's own test is built from - that called a cache losing money while it was 19% ahead.
 */
export const CACHE_BREAK_EVEN = (2 - 1) / (1 - 0.1);

/**
 * What the prompt cache is actually doing. `cacheWrite` is the expensive half - a write costs more
 * than sending the tokens uncached and only pays for itself once enough later turns read it - so
 * the ratio, not the raw totals, is the number that says whether caching is earning its keep.
 */
export const cacheUse = tokens => {
  if (!tokens) return null;
  const total = tokens.input + tokens.cacheRead + tokens.cacheWrite;
  if (total === 0) return null;
  return {
    total,
    // Nothing written is not a bad ratio, it is no writes to amortise.
    ratio: tokens.cacheWrite === 0 ? Infinity : tokens.cacheRead / tokens.cacheWrite,
    hitPct: 100 * tokens.cacheRead / total
  };
};